import React from 'react';
import { ZapIcon, TargetIcon } from 'lucide-react';
export function GainPointsSection() {
  const gainPoints = ['Pasarás de quedarte en blanco frente a un diagrama → a entenderlo paso a paso', 'Aprenderás la lógica real de los comandos eléctricos (no solo símbolos)', 'Podrás montar tableros sin depender de otro técnico', 'Evitarás errores que pueden costarte dinero o reputación', 'Tendrás más confianza para aceptar trabajos mejor pagados', 'Empezarás a verte como un técnico que sí sabe'];
  return <section className="bg-cream py-8 px-4" data-id="element-260">
      <div className="max-w-[600px] mx-auto" data-id="element-261">
        <h2 className="text-[24px] text-center font-bold text-brand-black mb-8 leading-[1.2] heading-underline flex items-center justify-center gap-2" data-id="element-262">
          <TargetIcon className="w-6 h-6 text-primary" data-id="element-263" />
          ¿QUÉ LOGRARÁS CON ESTE SISTEMA?
        </h2>

        <div className="bg-brand-black-light border border-white/10 rounded-xl p-6 shadow-soft" data-id="element-264">
          <div className="space-y-5" data-id="element-265">
            {gainPoints.map((point, index) => <div key={index} className="flex items-start gap-4" data-id="element-266">
                <ZapIcon className="w-6 h-6 text-primary flex-shrink-0 mt-0.5" data-id="element-267" />
                <p className="text-dark-gray text-[15px] leading-relaxed m-0" data-id="element-268">
                  {point}
                </p>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
}